import { useQuery } from "@tanstack/react-query";
import Tabs from "../../../elements/Tabs";
import AdvanceSettings from "./AdvanceSettings";
import Advertisement from "./Advertisement";
import UserPrivilege from "./UserPrivilege";
import UserProfile from "./UserProfile";
import { profileDetails, userDetails } from "../../../../services/userService";
import { initialsValue } from "../../../../helpers";
import Indentification from "../../../elements/Indentification";
import Subscription from "../../../../pages/admin/modules/Subscription";
import Transaction from "../../../../pages/admin/modules/Transaction";

const ManageUser = ({
  getResponse = () => { },
  close = () => { },
  data,
  selectedTab,
  setSelectedTab = () => { },
}) => {
  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useQuery({
    queryKey: ["user-details", data?._id],
    queryFn: async () => {
      const res = await userDetails({ id: data?._id });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  const tabs = [
    {
      label: "User Profile",
      icon: "fa-light fa-user",
      content: (
        <UserProfile
          details={details}
          getResponse={getResponse}
          loading={detailsLoading || detailsFetching}
        />
      ),
    },
    // ...(data?._id
    //   ? [
    //       {
    //         label: "Advance Settings",
    //         icon: "fa-light fa-gear",
    //         type: "image",
    //         content: (
    //           <AdvanceSettings
    //             details={details}
    //             getResponse={getResponse}
    //             loading={detailsLoading || detailsFetching}
    //           />
    //         ),
    //       },
    //       {
    //         label: "Subscription",
    //         icon: "fa-solid fa-money-check-dollar",
    //         type: "image",
    //         content: <Subscription />,
    //       },
    //       {
    //         label: "Transaction",
    //         icon: "fa-light fa-hand-holding-dollar",
    //         type: "image",
    //         content: <Transaction />,
    //       },
    //       {
    //         label: "Activity logs",
    //         icon: "fa-solid fa-list-timeline",
    //         type: "image",
    //         content: <div className="relative">Activity logs</div>,
    //       },
    //     ]
    //   : []),
  ];

  const name = data?.firstName + " " + data?.lastName;

  return (
    <div className="px-4 py-4 h-full">
      {data?._id && (
        <div className="flex items-center font-medium text-xl text-slate-600">
          <span className="text-[18px] text-slate-400">Users /</span>
          <div className="relative flex items-center ml-2">
            <Indentification
              initial={initialsValue(name)}
              image={data?.image?.url}
              alt={name}
              fill={true}
              className=""
              size="md"
            />
            <div className="text-md mx-2">{name}</div>
          </div>
        </div>
      )}

      <div className="relative">
        {/* <Tabs
          items={tabs}
          selectedIndex={selectedTab}
          setSelectedIndex={setSelectedTab}
        /> */}
        <UserProfile
          details={details}
          getResponse={getResponse}
          loading={detailsLoading || detailsFetching}
        />
      </div>
    </div>
  );
};

export default ManageUser;
